import { render } from "./IndustryDetail.vue?vue&type=template&id=7dd04bc0&scoped=true"
import script from "./IndustryDetail.vue?vue&type=script&lang=js"
export * from "./IndustryDetail.vue?vue&type=script&lang=js"

import "./IndustryDetail.vue?vue&type=style&index=0&id=7dd04bc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd04bc0"]])

export default __exports__